<template>
  <div class="card mgt-20px">
    <header class="header-card">
      <p>
        {{ $t('dispositifPublicitaire.montageDemontage') }}
      </p>
    </header>
    <div class="card-content columns is-multiline">
      <div class="column is-3">
        <b-field :label="$t('dispositifPublicitaire.dateMontage')">
          <b-datepicker show-week-number
            v-model="dispositifPublicitaire.dateMontage"
            icon="calendar-today"
            nearby-selectable-month-days
            :editable="true">
          </b-datepicker>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('dispositifPublicitaire.dateDemontage')">
          <b-datepicker show-week-number
            v-model="dispositifPublicitaire.dateDemontage"
            icon="calendar-today"
            nearby-selectable-month-days
            :editable="true">
          </b-datepicker>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('dispositifPublicitaire.etat')" class="obligatoire">
          <b-select v-model="dispositifPublicitaire.etat" expanded
            @input="$emit('etatMontageDemontageChanged')"
            :disabled="!dispositifPublicitaire.actif">
            <option v-for="etat in allEtat"
                    :value="etat.value" :key="etat.value">
              {{ $t(etat.libelle) }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ETAT_DISPOSITIF_PUBLICITAIRE, MONTE, DEMONTE,
  ETAT_DISPOSITIF_PUBLICITAIRE_MODULE_EMPLACEMENT,
} from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'montageDemontage',
  data() {
    return {
      // allEtat: ETAT_DISPOSITIF_PUBLICITAIRE,
      contantes: {
        MONTE,
        DEMONTE,
      },
    };
  },
  props: {
    dispositifPublicitaire: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleEmplacementClientActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key);
    },
    allEtat() {
      let listeEtat = ETAT_DISPOSITIF_PUBLICITAIRE;
      if (this.moduleEmplacementClientActive) {
        listeEtat = listeEtat.concat(ETAT_DISPOSITIF_PUBLICITAIRE_MODULE_EMPLACEMENT);
      }
      return listeEtat;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key,
      ]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
